<template>
  <div class="main-wrapper" >
    <div class="main-scroll">
      <nav-com  :flag='flag'></nav-com>
      <reg-com></reg-com>
      <foot-com class="foots"></foot-com>
    </div>
    <bottom-backtop></bottom-backtop>
  </div>
</template>

<script>
import NavCom from '../common/navs';
import FootCom from '../common/foots';
import regCom from './register';
import BottomBacktop from '../common/BottomBacktop';


export default {
  name: 'register',
  components: {
    NavCom,
    FootCom,
    regCom,
    BottomBacktop
  },
  data() {
    return {
      flag:false
    }
  },
}
</script>

<style lang="scss" scoped>



</style>
